import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _objectSpread2 from "@babel/runtime-corejs2/helpers/objectSpread";
import { ObSessionServiceInterface } from '@central-products/interface-obsession-service';
import ObSessionService from './ObSessionService';
var FEATURE_NAME = '@feature/obsession-service';
export var feature = {
  name: FEATURE_NAME,
  create: function create(config, dependencies) {
    return new ObSessionService(_objectSpread2({}, config), dependencies);
  },
  init: function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(instance) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", instance.init());

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function init(_x) {
      return _init.apply(this, arguments);
    }

    return init;
  }(),
  dependsOn: ['session-manager'],
  implements: ObSessionServiceInterface,
  role: 'obsession-service'
};
//# sourceMappingURL=feature.js.map